export enum GenreEnum {
  Masculino = "MASCULINO",
  Feminino = "FEMININO"
}

